import React, { memo } from 'react';

import { PageHeader } from '@components/PageHeader';
import { CardContainer } from '@components/CardContainer';

import { useThemeGetter } from '@hooks';

import { JobBlock } from './JobBlock';
import { StackBlock } from './StackBlock';

import { ExperienceContentContainer } from './ExperienceCard.styled';

export const ExperienceCard = memo(() => {
  const {
    theme: { TitleReverse },
  } = useThemeGetter();

  return (
    <CardContainer>
      <PageHeader headerColor={TitleReverse} text="Experience" />
      <ExperienceContentContainer>
        <JobBlock />
        <StackBlock />
      </ExperienceContentContainer>
    </CardContainer>
  );
});
